// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DateField + SelectMenu — form fields that open the app's own popovers
   (the shared calendar, a themed option list) instead of the browser's.
   Both sit inside an .rf-input-shell and fill it; the popover spans the
   whole shell (12px padding + 1px border either side). */

.rf-fp {
  position: relative;
  flex-grow: 1;
  min-width: 0;
  align-self: stretch;
  display: flex;
}
.rf-fp-btn {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  background: none;
  font: 400 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  text-align: left;
  cursor: pointer;
  outline: none;
}
.rf-fp-btn:disabled {
  color: #6f6a60;
  cursor: not-allowed;
}
.rf-fp-value {
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rf-fp-value.is-empty {
  color: #bdb6a7;
}
.rf-fp-caret {
  font-size: 10px;
  color: #a29b8d;
  transition: transform 0.15s;
}
.rf-fp-caret.is-open {
  transform: rotate(180deg);
}
/* a small calendar glyph drawn in CSS: a box with two binding rings */
.rf-fp-cal {
  position: relative;
  width: 13px;
  height: 12px;
  border: 1.5px solid #a29b8d;
  border-top-width: 3px;
  border-radius: 3px;
  flex-shrink: 0;
}
.rf-fp-btn:hover .rf-fp-cal,
.rf-fp-btn[aria-expanded="true"] .rf-fp-cal {
  border-color: var(--rf-brand);
}
.rf-fp-btn:focus-visible .rf-fp-value {
  text-decoration: underline;
  text-decoration-color: var(--rf-brand-lite, #d8cfb8);
  text-underline-offset: 3px;
}

/* ---------- the popover ---------- */
.rf-fp-pop {
  position: absolute;
  top: calc(100% + 7px);
  left: -13px;
  z-index: 70;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);
}
.rf-fp-pop.is-up {
  top: auto;
  bottom: calc(100% + 7px);
}

/* calendar — the work order list's popover, at the same size */
.rf-fp-cal-pop {
  width: 272px;
  padding: 14px;
}
.rf-fp-foot {
  display: flex;
  gap: 6px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f0ece3;
}
.rf-fp-foot button {
  height: 28px;
  padding: 0 11px;
  border: 1px solid #e2dcd0;
  border-radius: 7px;
  background: #fff;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #4a453c;
  cursor: pointer;
}
.rf-fp-foot button:hover {
  border-color: #d8cfb8;
  background: #faf8f4;
}
.rf-fp-foot button.is-quiet {
  margin-left: auto;
  border-color: transparent;
  color: #8b8477;
}

/* option list */
.rf-fp-menu {
  right: -13px;
  padding: 5px;
  max-height: 300px;
  overflow-y: auto;
}
.rf-fp-opt {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 10px;
  border-radius: 7px;
  font-size: 13.5px;
  color: #191714;
  cursor: pointer;
}
.rf-fp-opt span:first-child {
  flex-grow: 1;
}
.rf-fp-opt.is-active {
  background: #f4f1ea;
}
.rf-fp-opt.is-chosen {
  font-weight: 600;
  color: var(--rf-brand-deep);
}
.rf-fp-opt.is-chosen.is-active {
  background: var(--rf-brand-tint, #f6ecd8);
}
.rf-fp-tick {
  font-size: 12px;
  color: var(--rf-brand);
}
`, "",{"version":3,"sources":["webpack://./src/field-popovers.css"],"names":[],"mappings":"AAAA;;;yDAGyD;;AAEzD;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gEAAgE;EAChE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA,+DAA+D;AAC/D;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8DAA8D;EAC9D,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,sBAAsB;AACxB","sourcesContent":["/* DateField + SelectMenu — form fields that open the app's own popovers\n   (the shared calendar, a themed option list) instead of the browser's.\n   Both sit inside an .rf-input-shell and fill it; the popover spans the\n   whole shell (12px padding + 1px border either side). */\n\n.rf-fp {\n  position: relative;\n  flex-grow: 1;\n  min-width: 0;\n  align-self: stretch;\n  display: flex;\n}\n.rf-fp-btn {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0;\n  border: none;\n  background: none;\n  font: 400 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n}\n.rf-fp-btn:disabled {\n  color: #6f6a60;\n  cursor: not-allowed;\n}\n.rf-fp-value {\n  flex-grow: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rf-fp-value.is-empty {\n  color: #bdb6a7;\n}\n.rf-fp-caret {\n  font-size: 10px;\n  color: #a29b8d;\n  transition: transform 0.15s;\n}\n.rf-fp-caret.is-open {\n  transform: rotate(180deg);\n}\n/* a small calendar glyph drawn in CSS: a box with two binding rings */\n.rf-fp-cal {\n  position: relative;\n  width: 13px;\n  height: 12px;\n  border: 1.5px solid #a29b8d;\n  border-top-width: 3px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n.rf-fp-btn:hover .rf-fp-cal,\n.rf-fp-btn[aria-expanded=\"true\"] .rf-fp-cal {\n  border-color: var(--rf-brand);\n}\n.rf-fp-btn:focus-visible .rf-fp-value {\n  text-decoration: underline;\n  text-decoration-color: var(--rf-brand-lite, #d8cfb8);\n  text-underline-offset: 3px;\n}\n\n/* ---------- the popover ---------- */\n.rf-fp-pop {\n  position: absolute;\n  top: calc(100% + 7px);\n  left: -13px;\n  z-index: 70;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  box-shadow: 0 14px 40px rgba(40, 34, 22, 0.16);\n}\n.rf-fp-pop.is-up {\n  top: auto;\n  bottom: calc(100% + 7px);\n}\n\n/* calendar — the work order list's popover, at the same size */\n.rf-fp-cal-pop {\n  width: 272px;\n  padding: 14px;\n}\n.rf-fp-foot {\n  display: flex;\n  gap: 6px;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #f0ece3;\n}\n.rf-fp-foot button {\n  height: 28px;\n  padding: 0 11px;\n  border: 1px solid #e2dcd0;\n  border-radius: 7px;\n  background: #fff;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #4a453c;\n  cursor: pointer;\n}\n.rf-fp-foot button:hover {\n  border-color: #d8cfb8;\n  background: #faf8f4;\n}\n.rf-fp-foot button.is-quiet {\n  margin-left: auto;\n  border-color: transparent;\n  color: #8b8477;\n}\n\n/* option list */\n.rf-fp-menu {\n  right: -13px;\n  padding: 5px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n.rf-fp-opt {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 10px;\n  border-radius: 7px;\n  font-size: 13.5px;\n  color: #191714;\n  cursor: pointer;\n}\n.rf-fp-opt span:first-child {\n  flex-grow: 1;\n}\n.rf-fp-opt.is-active {\n  background: #f4f1ea;\n}\n.rf-fp-opt.is-chosen {\n  font-weight: 600;\n  color: var(--rf-brand-deep);\n}\n.rf-fp-opt.is-chosen.is-active {\n  background: var(--rf-brand-tint, #f6ecd8);\n}\n.rf-fp-tick {\n  font-size: 12px;\n  color: var(--rf-brand);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
